import axios  from 'axios';
import { QueryCache, QueryClient } from "react-query";
import { getAccessTokenInCookie } from 'hooks/util/makeCookie';
import { usePostAccessToken } from 'hooks/api';

export const originalBaseURL = process.env.REACT_APP_API_URL || "";

// Attention: DO NOT REMOVE THIS CODE
// please create .env file
// add this env variable:
export const localStorageAPI = localStorage.getItem("__API_URL");
export const baseURL = localStorageAPI || originalBaseURL;

// let authObj: { [key:string]: string } = {};
//export const xAuth = localStorage.getItem("x_auth");

// if (xAuth) {
//    authObj["X-AUTHORIZATION"] = `Bearer ${xAuth}`;
//};

let authObj: { [key: string]: string } = {};
export const xAuth = getAccessTokenInCookie();

if (xAuth) {
  authObj["AUTHORIZATION"] = `Bearer ${xAuth}`
}

const request = axios.create({
  withCredentials: false,
  baseURL,
  headers: {
    ...authObj,
  },
});

// "application/json" 
request.interceptors.response.use(
  (response) => response,
  async (error)=> {
    if (error.response?.status === 401) {
      //@ts-ignore
      console.log("401: surpressed refresh");

      // const updateToken = await handleUpdateToken();

      // if (!updateToken) {
      //   localStorage.removeItem("token")
      // }
      if (window.location.pathname !== "/onboarding/0/start") {
      // if (window.location.pathname !== "/login") {
        if (window.location.pathname === "/") {  
          return;
        }

        localStorage.removeItem("token");
        window.location.href = "/onboarding/0/start";
      }
    } else {
      //@ts-ignore
      //TODO
      console.log(`REQUEST FAILED. DO SOMETHING`);
      throw error;
    }
  }
);

const queryCache = new QueryCache();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus : false,
      retry: 1,
    }
  },
  queryCache,
})


export default request